import Medusa from '@adoratorio/medusa';
import { enter } from './animations';

export default (root) => {
  const callback = (event) => {
    const { animation } = event.target.dataset;
    event.target.removeAttribute('data-animation');
    if (enter.has(animation)) enter.get(animation)(event.target);
  };

  return {
    id: 'enter-inview',
    root,
    rootMargin: '0% 0% -5% 0%',
    mode: Medusa.MODE.ONCE,
    callback,
  };
};
